import { Check } from "@mui/icons-material";
import { Badge } from "@mui/material";
import { PropsWithChildren } from "react";

export type StepMenuLandingCardAvatarProps = {
    isValid: boolean;
};

export default function StepMenuLandingCardAvatar({
    isValid,
    children,
}: PropsWithChildren<StepMenuLandingCardAvatarProps>) {

    return (
        <Badge
            badgeContent={isValid
                ? <Check sx={{
                      height: "16px",
                       width: "16px",
                    }}/>
                : undefined
            }
            color="secondary"
            sx={{
                "& .MuiBadge-badge": {
                    padding: 0,
                    bottom: 8,
                    border: theme => `2px solid ${theme.palette.background.paper}`
                }
            }}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "right"
            }}
        >
            {children}
        </Badge>
    );
}